import { showUserAlert } from "../../utils/userErrorMessage";
// CarExpenseForm.jsx
import React, { useState } from "react";
import { supabase } from "../../supabase/client";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";

export default function CarExpenseForm() {
  const [form, setForm] = useState({
    date: "",
    car_number: "",
    human_name: "",
    johab: 0,
    unyoung: 0,
    gps: 0,
    halbu: 0,
    geubyeo: 0,
    bohum: 0,
    sooksic: 0,
    jungbi: 0,
    jooyu: 0,
    secha: 0,
    "4bohum": 0,
    tonghaeng: 0,
    joocha: 0,
    chooljang: 0,
    gwatae: 0,
    gita: 0,
    bigo: ""
  });


  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleSubmit = async () => {
    const company = localStorage.getItem("email");
    if (!company) return showUserAlert("회사 정보가 없습니다. 다시 로그인해 주세요.");
    const { error } = await supabase.from("cars-expenses").insert({ ...form, company });
    if (error) showUserAlert("등록 실패: " + error.message);
    else showUserAlert("차량 지출이 등록되었습니다.");
  };
    const fields = [
        "johab", "unyoung", "gps", "halbu", "geubyeo", "4bohum",
        "tonghaeng", "joocha", "sooksic", "jungbi", "jooyu", "bohum",
        "secha", "chooljang", "gwatae", "gita"
    ];

    const fieldLabels = {
        johab: "조합비", unyoung: "운영비", gps: "GPS", halbu: "할부금", geubyeo: "급여", "4bohum": "4대보험",
        tonghaeng: "통행료", joocha: "주차료", sooksic: "숙식비", jungbi: "정비비", jooyu: "주유비", bohum: "보험료",
        secha: "세차료", chooljang: "출장비", gwatae: "과태료", gita: "기타비"
    };

  return (
    <div className="p-4 space-y-4">
      <h2 className="text-lg font-semibold">차량 지출 등록</h2>
      <Card>
        <CardContent className="space-y-4 bg-white">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block font-semibold mb-1">지출일</label>
              <Input type="date" value={form.date} onChange={e => handleChange("date", e.target.value)} />
            </div>
            <div className="relative">
              <label className="block font-semibold mb-1">기사명</label>
              <Input
                value={form.human_name}
                // onClick={handleDriverClick}
                onChange={e => handleChange("human_name", e.target.value)}
                className="cursor-pointer"
              />
              {/*{driverSearchResults.length > 0 && (
                <ul className="absolute z-10 bg-white border rounded w-full max-h-40 overflow-y-auto">
                  {driverSearchResults.map((name, idx) => (
                    <li
                      key={idx}
                      className="p-2 hover:bg-gray-200 cursor-pointer"
                      onClick={() => selectDriver(name)}
                    >
                      {name}
                    </li>
                  ))}
                </ul>
              )}*/}
            </div>
            <div className="relative">
              <label className="block font-semibold mb-1">차량번호</label>
              <Input
                value={form.car_number}
                // onClick={handleCarClick}
                onChange={e => handleChange("car_number", e.target.value)}
                className="cursor-pointer"
              />
              {/*{carSearchResults.length > 0 && (
                <ul className="absolute z-10 bg-white border rounded w-full max-h-40 overflow-y-auto">
                  {carSearchResults.map((num, idx) => (
                    <li
                      key={idx}
                      className="p-2 hover:bg-gray-200 cursor-pointer"
                      onClick={() => selectCarNumber(num)}
                    >
                      {num}
                    </li>
                  ))}
                </ul>
              )}*/}
            </div>
            
            {fields.map((key) => (
              <div key={key}>
                <label className="block font-semibold mb-1">{fieldLabels[key]}</label>
                <Input
                  type="number"
                  value={form[key]}
                  onChange={(e) => handleChange(key, parseInt(e.target.value) || 0)}
                />
              </div>
            ))}
            <div className="md:col-span-2">
              <label className="block font-semibold mb-1">비고</label>
              <Input type="text" value={form.bigo} onChange={(e) => handleChange("bigo", e.target.value)} />
            </div>
          </div>
          <div className="pt-4">
            <Button onClick={handleSubmit}>등록</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
